import './style.scss';

// Buttons Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
    const components = document.querySelectorAll('.booom-buttons');
    
    // components.forEach(function(component) {
    // });
});
